/* sos-shop-fix-20260826 */
/* SOS Hydration theme — cart, UI motion, science scrub */
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.SOS && window.SOS.routes && window.SOS.routes.root) || '/';
  const routes = Object.assign(
    {
      cart_url: root + 'cart',
      cart_add_url: root + 'cart/add',
      cart_change_url: root + 'cart/change',
      cart_update_url: root + 'cart/update'
    },
    (window.SOS && window.SOS.routes) || {}
  );

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.SOS && window.SOS.moneyFormat) {
      return Shopify.formatMoney(cents, window.SOS.moneyFormat);
    }
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  async function fetchCart() {
    const res = await fetch(routes.cart_url + '.js', { credentials: 'same-origin' });
    return res.json();
  }

  function updateCartCount(count) {
    $$('[data-cart-count], .cart-count').forEach((el) => {
      el.textContent = String(count);
    });
  }

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function updateShipBar(cart) {
    const bar = $('[data-shipbar]');
    if (!bar) return;
    const threshold = Number(bar.dataset.threshold || 0) || (window.SOS && window.SOS.freeShipThreshold) || 0;
    if (!threshold) {
      bar.style.display = 'none';
      return;
    }
    const msg = bar.querySelector('[data-shipbar-msg]');
    const fill = bar.querySelector('[data-shipbar-fill]');
    const remaining = threshold - cart.total_price;
    if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    if (msg) {
      if (remaining <= 0) {
        msg.innerHTML = "You've unlocked <strong>free shipping</strong>.";
        bar.classList.add('is-complete');
      } else {
        msg.innerHTML = "You're <strong>" + formatMoney(remaining) + '</strong> away from free shipping.';
        bar.classList.remove('is-complete');
      }
    }
  }

  function renderCartDrawer(cart) {
    const body = $('[data-cart-body], #cart-body');
    const total = $('[data-cart-total], #cart-total-value');
    updateCartCount(cart.item_count);
    updateShipBar(cart);
    if (!body) return;
    if (total) total.textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-empty" id="cart-empty">Empty. Don\'t be a raisin.</p>';
      return;
    }
    body.innerHTML = cart.items
      .map((item) => {
        const img = item.image
          ? `<img src="${item.image.replace(/(\.[^.]*)(\?|$)/, '_112x$1$2')}" alt="" loading="lazy" />`
          : '';
        const meta = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
        return `<div class="cart-line" data-key="${esc(item.key)}">${img}<div class="cart-line__info"><div class="cart-line__name">${esc(item.product_title)}</div><div class="cart-line__meta">${meta}</div><div class="cart-line__controls"><div class="qty qty--sm" data-line-qty><button type="button" data-qty-down aria-label="Decrease">−</button><input type="text" inputmode="numeric" value="${item.quantity}" data-qty-value aria-label="Quantity" readonly><button type="button" data-qty-up aria-label="Increase">+</button></div><button type="button" class="cart-line__remove" data-remove>Remove</button></div></div><div class="cart-line__price">${formatMoney(item.final_line_price)}</div></div>`;
      })
      .join('');
  }

  async function changeCart(key, quantity) {
    const res = await fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    const cart = await res.json();
    renderCartDrawer(cart);
    return cart;
  }

  async function refreshCartUI() {
    try {
      const cart = await fetchCart();
      renderCartDrawer(cart);
      return cart;
    } catch (e) {
      console.warn('Cart refresh failed', e);
    }
  }

  async function addToCart(variantId, quantity, options = {}) {
    const item = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (options.sellingPlan) item.selling_plan = Number(options.sellingPlan);
    const res = await fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    await refreshCartUI();
    openCart();
    const btn = $('#cart-btn');
    if (btn) {
      btn.classList.remove('is-pulse');
      void btn.offsetWidth;
      btn.classList.add('is-pulse');
    }
  }

  window.SOS = window.SOS || {};
  window.SOS.addToCart = addToCart;

  function openCart() {
    if (window.SOS && window.SOS.cartDrawer === false) {
      window.location.href = routes.cart_url;
      return;
    }
    $('#cart-drawer')?.classList.add('is-open');
    $('#cart-overlay')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    $('#cart-drawer')?.classList.remove('is-open');
    $('#cart-overlay')?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  const header = $('#site-header');
  const announcement = $('#site-announcement') || $('.announcement');
  const syncChrome = () => {
    if (!announcement) {
      document.documentElement.style.setProperty('--announce-h', '0px');
      return;
    }
    const height = announcement.offsetHeight || 0;
    const rect = announcement.getBoundingClientRect();
    const visible = Math.max(0, Math.min(height, rect.bottom));
    document.documentElement.style.setProperty('--announce-h', `${visible}px`);
  };
  const onScroll = () => {
    header?.classList.toggle('is-scrolled', window.scrollY > 30);
    syncChrome();
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', syncChrome, { passive: true });
  syncChrome();
  onScroll();

  const navToggle = $('#nav-toggle');
  const nav = $('#site-nav');
  navToggle?.addEventListener('click', () => {
    const open = nav?.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  $$('#site-nav a').forEach((a) =>
    a.addEventListener('click', () => {
      nav?.classList.remove('is-open');
      navToggle?.setAttribute('aria-expanded', 'false');
    })
  );
  $('#cart-btn')?.addEventListener('click', openCart);
  $('#cart-close')?.addEventListener('click', closeCart);

  $('#cart-body')?.addEventListener('click', async (e) => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    const key = line.dataset.key;
    const input = line.querySelector('[data-qty-value]');
    let q = Number(input?.value || 1);
    if (e.target.closest('[data-qty-up]')) q += 1;
    else if (e.target.closest('[data-qty-down]')) q -= 1;
    else if (e.target.closest('[data-remove]')) q = 0;
    else return;
    line.style.opacity = '0.5';
    try {
      await changeCart(key, Math.max(0, q));
    } catch (err) {
      console.warn('Cart update failed', err);
      line.style.opacity = '';
    }
  });
  $('#cart-overlay')?.addEventListener('click', closeCart);
  addEventListener('keydown', (e) => e.key === 'Escape' && closeCart());

  const spot = $('#spotlight');
  if (spot && !reduce && matchMedia('(pointer:fine)').matches) {
    document.body.classList.add('is-pointer');
    let x = innerWidth / 2;
    let y = innerHeight * 0.4;
    let tx = x;
    let ty = y;
    addEventListener('pointermove', (e) => { tx = e.clientX; ty = e.clientY; }, { passive: true });
    (function loop() {
      x += (tx - x) * 0.08;
      y += (ty - y) * 0.08;
      spot.style.left = x + 'px';
      spot.style.top = y + 'px';
      requestAnimationFrame(loop);
    })();
  }

  if (!reduce && matchMedia('(pointer:fine)').matches) {
    $$('.magnetic').forEach((btn) => {
      btn.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        btn.style.transform = `translate(${(e.clientX - (r.left + r.width / 2)) * 0.18}px, ${(e.clientY - (r.top + r.height / 2)) * 0.22}px)`;
      });
      btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
    });
  }

  // 3D tilt disabled — was causing zoom-like transforms on product images
  // (runway / PDP / cards). Keep motion elsewhere.

  // Scroll parallax on tagged layers
  const parallaxEls = $$('[data-parallax]');
  if (parallaxEls.length && !reduce) {
    let pTicking = false;
    const updateParallax = () => {
      const y = window.scrollY;
      parallaxEls.forEach((el) => {
        const s = parseFloat(el.dataset.parallax) || 0;
        el.style.transform = `translate3d(0, ${(y * s).toFixed(1)}px, 0)`;
      });
      pTicking = false;
    };
    addEventListener('scroll', () => {
      if (!pTicking) { requestAnimationFrame(updateParallax); pTicking = true; }
    }, { passive: true });
    updateParallax();
  }

  const reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  requestAnimationFrame(() => {
    $$('[data-hero-time]').forEach((hero) => {
      if (typeof hero._sosApplyHeroSlot === 'function') hero._sosApplyHeroSlot();
      hero.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
    });
    $('.hero')?.classList.add('is-ready');
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    $$('[data-hero-time]').forEach((hero) => {
      if (typeof hero._sosApplyHeroSlot === 'function') hero._sosApplyHeroSlot();
      hero.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
    });
  });

  function animateCount(el) {
    const target = parseFloat(el.dataset.count || '0');
    const suffix = el.dataset.suffix || '';
    const start = performance.now();
    function frame(now) {
      const t = Math.min(1, (now - start) / 1200);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  const counters = $$('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    const cio = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            animateCount(en.target);
            cio.unobserve(en.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach((el) => cio.observe(el));
  }

  const chapters = $$('.chapter');
  const scienceRoot = $('[data-science]');
  const meter = $('#meter-fill');
  const meterLabel = $('#meter-label');
  if (chapters.length && scienceRoot) {
    let sTicking = false;
    const updateScience = () => {
      const viewMid = innerHeight * 0.45;
      let pct = parseFloat(chapters[0].dataset.meter || '0');
      let best = chapters[0];
      let bestScore = -Infinity;

      for (let i = 0; i < chapters.length; i++) {
        const ch = chapters[i];
        const r = ch.getBoundingClientRect();
        const mid = r.top + r.height / 2;
        const score = -Math.abs(mid - viewMid);
        if (score > bestScore) {
          bestScore = score;
          best = ch;
        }

        if (i === 0 && mid >= viewMid) {
          pct = parseFloat(ch.dataset.meter || '0');
          break;
        }

        if (i > 0) {
          const prev = chapters[i - 1];
          const prevR = prev.getBoundingClientRect();
          const prevMid = prevR.top + prevR.height / 2;
          if (viewMid <= mid && viewMid >= prevMid) {
            const span = Math.max(1, mid - prevMid);
            const t = Math.min(1, Math.max(0, (viewMid - prevMid) / span));
            const m0 = parseFloat(prev.dataset.meter || '0');
            const m1 = parseFloat(ch.dataset.meter || '0');
            pct = m0 + (m1 - m0) * t;
            break;
          }
        }

        if (i === chapters.length - 1 && mid <= viewMid) {
          pct = parseFloat(ch.dataset.meter || '100');
        }
      }

      chapters.forEach((ch) => ch.classList.toggle('is-active', ch === best));
      scienceRoot.style.setProperty('--meter', pct.toFixed(2));
      if (meter) meter.style.width = `${pct.toFixed(2)}%`;
      if (meterLabel) {
        const rounded = Math.round(pct);
        meterLabel.textContent = rounded >= 98 ? '4× absorption' : `Absorption ${rounded}%`;
      }
      sTicking = false;
    };
    addEventListener(
      'scroll',
      () => {
        if (!sTicking) {
          requestAnimationFrame(updateScience);
          sTicking = true;
        }
      },
      { passive: true }
    );
    updateScience();
  } else if (chapters.length) {
    const meterEl = $('#meter-fill');
    const meterLabelEl = $('#meter-label');
    const activate = () => {
      let best = chapters[0];
      let bestScore = -Infinity;
      chapters.forEach((ch) => {
        const r = ch.getBoundingClientRect();
        const score = -Math.abs(r.top + r.height / 2 - innerHeight * 0.45);
        if (score > bestScore) {
          bestScore = score;
          best = ch;
        }
      });
      chapters.forEach((ch) => ch.classList.toggle('is-active', ch === best));
      const pct = best?.dataset.meter || '0';
      if (meterEl) meterEl.style.width = pct + '%';
      if (meterLabelEl) meterLabelEl.textContent = pct === '100' ? '4× absorption' : `Absorption ${pct}%`;
    };
    addEventListener('scroll', activate, { passive: true });
    activate();
  }

  const transformSection = $('[data-transform]');
  const transformStage = $('[data-transform-stage]');
  if (transformSection && transformStage && !reduce) {
    const meterFill = $('[data-transform-meter]');
    const meterText = $('[data-transform-meter-label]');
    let tTicking = false;
    const updateTransform = () => {
      const rect = transformSection.getBoundingClientRect();
      const stickyEl = transformSection.querySelector('.transform__sticky');
      const stickyH = stickyEl ? stickyEl.offsetHeight : innerHeight;
      const travel = Math.max(1, transformSection.offsetHeight - stickyH);
      const scrolled = Math.min(travel, Math.max(0, -rect.top));
      const raw = scrolled / travel;
      // Ease the wipe so mobile doesn't feel binary
      const p = Math.min(1, Math.max(0, raw < 0.5 ? 2 * raw * raw : 1 - Math.pow(-2 * raw + 2, 2) / 2));
      transformStage.style.setProperty('--p', p.toFixed(4));
      if (meterFill) meterFill.style.width = `${(p * 100).toFixed(1)}%`;
      if (meterText) {
        meterText.textContent = p < 0.33 ? 'Raisin' : p < 0.66 ? 'Activating' : 'Hero';
      }
      tTicking = false;
    };
    addEventListener(
      'scroll',
      () => {
        if (!tTicking) {
          requestAnimationFrame(updateTransform);
          tTicking = true;
        }
      },
      { passive: true }
    );
    addEventListener('resize', updateTransform, { passive: true });
    updateTransform();
  } else if (transformStage) {
    transformStage.style.setProperty('--p', '1');
  }

  const chips = $$('.filter-chip');
  const products = $$('.product[data-format]');
  function applyFilters() {
    const active = chips.filter((c) => c.classList.contains('is-active')).map((c) => c.dataset.filter);
    const formats = active.filter((f) => ['packets', 'tubs', 'bundles'].includes(f));
    products.forEach((p) => {
      const okF = !formats.length || formats.includes(p.dataset.format) || active.includes('all');
      p.classList.toggle('is-hidden', !(okF || active.includes('all') || !formats.length));
      if (formats.length) p.classList.toggle('is-hidden', !formats.includes(p.dataset.format));
    });
  }
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      if (chip.dataset.filter === 'all') {
        chips.forEach((c) => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      } else {
        chips.find((c) => c.dataset.filter === 'all')?.classList.remove('is-active');
        chip.classList.toggle('is-active');
        if (!chips.some((c) => c.classList.contains('is-active'))) {
          chips.find((c) => c.dataset.filter === 'all')?.classList.add('is-active');
        }
      }
      applyFilters();
    });
  });

  function setPdpImage(src) {
    const main = $('#pdp-main-img');
    if (!main || !src) return;
    // Normalize protocol-relative CDN URLs
    const next = src.startsWith('//') ? `https:${src}` : src;
    if (main.getAttribute('src') === next && !main.getAttribute('srcset')) return;
    main.style.opacity = '0';
    const pre = new Image();
    pre.onload = () => {
      // Shopify image_tag ships srcset; leaving it set keeps the old image visible
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = next;
      main.style.opacity = '1';
    };
    pre.onerror = () => {
      main.style.opacity = '1';
    };
    pre.src = next;
  }

  $$('.pdp__thumb').forEach((thumb) =>
    thumb.addEventListener('click', () => {
      $$('.pdp__thumb').forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
      setPdpImage(thumb.dataset.src);
    })
  );

  let qty = 1;
  const qtyInput = $('#qty-input');
  $('#qty-minus')?.addEventListener('click', () => {
    qty = Math.max(1, qty - 1);
    if (qtyInput) qtyInput.value = String(qty);
  });
  $('#qty-plus')?.addEventListener('click', () => {
    qty = Math.min(12, qty + 1);
    if (qtyInput) qtyInput.value = String(qty);
  });

  const productForm = $('#product-form');
  const stickyAtc = $('[data-pdp-sticky-atc]');
  const stickyButton = $('[data-pdp-sticky-button]');
  const stickyPrice = $('[data-pdp-sticky-price]');
  const primaryAtc = $('#pdp-atc');
  const rechargeSlot = $('[data-recharge-slot]');

  if (rechargeSlot) {
    const mountRecharge = () => {
      const rechargeBlock = $('.shopify-app-block.recharge-subscription-widget');
      if (!rechargeBlock) return false;
      if (!rechargeSlot.contains(rechargeBlock)) rechargeSlot.appendChild(rechargeBlock);
      return true;
    };

    if (!mountRecharge()) {
      const rechargeObserver = new MutationObserver(() => {
        if (mountRecharge()) rechargeObserver.disconnect();
      });
      rechargeObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => rechargeObserver.disconnect(), 10000);
    }
  }

  stickyButton?.addEventListener('click', () => {
    if (!stickyButton.disabled) productForm?.requestSubmit();
  });

  if (stickyAtc && primaryAtc && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      const hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyAtc.classList.toggle('is-visible', hasPassedButton);
      stickyAtc.setAttribute('aria-hidden', hasPassedButton ? 'false' : 'true');
    });
    stickyObserver.observe(primaryAtc);
  }

  productForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const id = productForm.querySelector('[name="id"]')?.value;
    const quantity = Number(qtyInput?.value || 1);
    const sellingPlan = new FormData(productForm).get('selling_plan');
    if (!id) return;
    try {
      await addToCart(id, quantity, { sellingPlan });
    } catch (err) {
      alert(err.message);
    }
  });

  $$('[data-add]').forEach((btn) =>
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const id = btn.dataset.variantId || btn.dataset.add;
      if (!id) return;
      try {
        await addToCart(id, 1);
      } catch (err) {
        alert(err.message);
      }
    })
  );

  const productJson = document.querySelector('[id^="ProductJson-"]');
  let product = null;
  if (productJson) {
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      console.warn('Product JSON parse failed', e);
    }
  }

  const optionButtons = $$('.flavour-swatch[data-option-position]');
  if (optionButtons.length) {
    const idInput = productForm?.querySelector('[name="id"]');
    const priceEl = $('#pdp-price');
    const atc = primaryAtc;

    const optionCount = product
      ? product.options.length
      : optionButtons.reduce((m, b) => Math.max(m, Number(b.dataset.optionPosition) || 0), 0);

    const selectedOptions = () => {
      const opts = [];
      for (let i = 0; i < optionCount; i++) {
        const active = $(`.flavour-swatch[data-option-position="${i + 1}"].is-active`);
        opts[i] = active ? active.dataset.value : product && product.variants[0].options[i];
      }
      return opts;
    };

    const findVariant = (opts) =>
      product && product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    optionButtons.forEach((btn) =>
      btn.addEventListener('click', () => {
        // Highlight always works, independent of product data
        const pos = btn.dataset.optionPosition;
        $$(`.flavour-swatch[data-option-position="${pos}"]`).forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        if (!product) return;
        const variant = findVariant(selectedOptions());
        if (atc) {
          if (!variant) {
            atc.disabled = true;
            atc.textContent = 'Unavailable';
          } else {
            atc.disabled = !variant.available;
            atc.textContent = variant.available ? 'Add to bag' : 'Sold out';
          }
        }
        if (stickyButton) {
          stickyButton.disabled = !variant || !variant.available;
          stickyButton.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to bag' : 'Sold out';
        }
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          const money = formatMoney(variant.price);
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? `${money} <span class="was">${formatMoney(variant.compare_at_price)}</span>`
            : money;
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (variant.featured_image && variant.featured_image.src) {
          setPdpImage(variant.featured_image.src);
        }
      })
    );
  }

  refreshCartUI();

  const hash = location.hash.replace('#', '');
  if (['packets', 'tubs', 'bundles'].includes(hash)) {
    $$('.filter-chip').forEach((c) => c.classList.toggle('is-active', c.dataset.filter === hash));
    applyFilters();
  }
})();
